var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.row.gross_potential_percentage > 0)?_c('thin-line-pie-chart',{attrs:{"animate":false,"percentage":_vm.row.gross_potential_percentage / 100}}):_c('div',{staticClass:"text-center"},[_vm._v("—")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }